(function () {
  function rewrite(form) {
    try {
      if (!form || !form.action) return;
      var path;
      try {
        path = new URL(form.action, window.location.origin).pathname;
      } catch (e) {
        return;
      }
      if (!/\/search\/?$/.test(path)) return;
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var value = (input.value || '').trim();
      if (!value) return;
      if (value.indexOf('"') !== -1 || value.indexOf(':') !== -1) return;
      var terms = value.split(/\s+/).filter(function (t) { return t.length > 0; });
      if (!terms.length) return;
      input.value = terms.map(function (t) { return '"' + t + '"'; }).join(' AND ');
    } catch (e) {
      /* Any error: leave the shopper's value untouched. */
    }
  }
  document.addEventListener('submit', function (event) {
    rewrite(event.target);
  }, true);
})();
